import { render, staticRenderFns } from "./SpecDeliveryEditor.vue?vue&type=template&id=eefb6488&scoped=true&lang=pug&"
import script from "./SpecDeliveryEditor.vue?vue&type=script&lang=js&"
export * from "./SpecDeliveryEditor.vue?vue&type=script&lang=js&"
import style0 from "./SpecDeliveryEditor.vue?vue&type=style&index=0&id=eefb6488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefb6488",
  null
  
)

export default component.exports